import { useQuery } from '@apollo/client'

import { useDispatch } from 'react-redux';
import { bindActionCreators } from 'redux';
import { authCreator } from 'state';
import { ME } from '../queries/authQueries';

const useMe = () => {
	const dispatch = useDispatch();
	const { me } = bindActionCreators(authCreator, dispatch)

	return useQuery(ME, {
		onCompleted: (data: any) => {
			me(data.me);
		}
	});
};

export {
    useMe
}
